import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchList = async (path, params = {}) => {
  const cleaned = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined && v !== "all"),
  );
  const res = await api.get(path, { params: cleaned });
  return res.data;
};

export const subscribeNewsletter = (payload) => api.post("/newsletter", payload);

export const adminLogin = (password) => api.post("/admin/login", { password });

export const adminList = (type, password) =>
  api.get(`/admin/${type}`, { headers: { "X-Admin-Password": password } });

export const adminCreate = (type, payload, password) =>
  api.post(`/admin/${type}`, payload, { headers: { "X-Admin-Password": password } });

export const adminUpdate = (type, id, payload, password) =>
  api.put(`/admin/${type}/${id}`, payload, { headers: { "X-Admin-Password": password } });

export const adminDelete = (type, id, password) =>
  api.delete(`/admin/${type}/${id}`, { headers: { "X-Admin-Password": password } });

export const adminListSubscribers = (password) =>
  api.get(`/admin/subscribers`, { headers: { "X-Admin-Password": password } });

export const adminDeleteSubscriber = (id, password) =>
  api.delete(`/admin/subscribers/${id}`, { headers: { "X-Admin-Password": password } });

export const adminListSubmissions = (password) =>
  api.get(`/admin/submissions`, { headers: { "X-Admin-Password": password } });

export const adminUpdateSubmission = (id, payload, password) =>
  api.put(`/admin/submissions/${id}`, payload, { headers: { "X-Admin-Password": password } });

export const adminDeleteSubmission = (id, password) =>
  api.delete(`/admin/submissions/${id}`, { headers: { "X-Admin-Password": password } });

export const adminListMessages = (password) =>
  api.get(`/admin/messages`, { headers: { "X-Admin-Password": password } });

export const adminUpdateMessage = (id, payload, password) =>
  api.put(`/admin/messages/${id}`, payload, { headers: { "X-Admin-Password": password } });

export const adminDeleteMessage = (id, password) =>
  api.delete(`/admin/messages/${id}`, { headers: { "X-Admin-Password": password } });

export const adminTechPopularity = (days, password) =>
  api.get(`/admin/tech-popularity`, { params: { days }, headers: { "X-Admin-Password": password } });

export const adminNewsletterCandidates = (language, password) =>
  api.get(`/admin/newsletter/candidates`, { params: { language }, headers: { "X-Admin-Password": password } });

export const adminNewsletterPreview = (payload, password) =>
  api.post(`/admin/newsletter/preview`, payload, { headers: { "X-Admin-Password": password } });

export const adminNewsletterSend = (payload, password) =>
  api.post(`/admin/newsletter/send`, payload, { headers: { "X-Admin-Password": password } });

